import { Component, Input, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environment/environment';
import { UrlService } from '@core/services/url/url.service';
import { AccountSession } from '@core/objects/account-session';

@Component({
    selector: 'core-helpers-navigation-header-menu',
    templateUrl: './header-menu.component.html',
    styleUrls: ['./header-menu.component.scss']
})
export class HelperNavigationHeaderMenuComponent implements OnInit{
    @Input() session: any;
    @Input() accountSession: AccountSession;

    @Output() newOrganization = new EventEmitter<number>();

    private wasInside: boolean = false;
    public menu: any[] = [];
    public show: boolean = false;
    public closed: boolean = true;
    public initialized: boolean = false;
    public organizations = [];

    public showChangeOrg:boolean = false;
    public showSwitchApp:boolean = false;

    protected settingsAccess = [
        'access_setting_tokens_access',
        'access_setting_groups_access',
        'access_setting_categories_access',
        'access_setting_users_access',
        'access_setting_rules_access',
        'access_setting_versions_access',
        'access_setting_workflows_access'
    ];

    protected appMenu: any = [
    ];

    @HostListener('click')
    clickInside() {
        // console.log("click inside")
        this.wasInside = true;
      

    }
  
    @HostListener('document:click')
    clickout() {
        if (!this.wasInside) {
            this.show = false;
            this.closed = true; // <--- IMPORTANTE
        }
        this.wasInside = false;
    } 
    
    constructor(private http: HttpClient, 
        private urlSrv: UrlService,
        // private router: Router,
        private breakpointObserver: BreakpointObserver
    ) { }

    ngOnInit(){
        this.session.current.organizations.length > 1 ? this.showChangeOrg = true : this.showChangeOrg = false;

        // Prefer the accounts-api apps list; fall back to the legacy session field in case the
        // (separate, parallel) accounts-api call hasn't resolved yet when this component initializes.
        const apps = this.accountSession?.current?.apps ?? this.session?.options?.organization?.apps;
        this.showSwitchApp = (apps?.length ?? 0) > 1;

        this.appMenu = [
            {
                expose: this.isProfileAccess(),
                name: 'Profile',
                class: 'tw2-drop-profile',
                href: environment.profileBaseUri // new profile app, opened in a new tab
            },
            {   
                expose: this.isSettingsAccess(),
                name: 'System settings',
                class: 'tw2-drop-settings',
                link: '/settings'
            }
        ];

        for (let key of this.appMenu){
            //return this.isAccess(key.access) ? this.menu.push(key) : false;
            if(key.expose) this.menu.push(key);
        }
    }

    /**
     * This function is used to logout the user.
     * @param event 
     */
    logout(event){
        event.stopPropagation();
        this.closeMenu();
        // window.location.href = "/web/logout";

        const logoutUrl = this.urlSrv.buildLogin('/logout');

        this.http.get(logoutUrl).subscribe({
            next: (response: any) => {
                console.log(" =====>>>>> logout success")
                window.location.href = environment.loginBaseUri;
            },
            error: (err: HttpErrorResponse )=> {
                console.log("=====>>>>> error on logout ",err);
            }
        });
    }

    isAccess(key: string) : boolean {
        return this.session.options.access.hasOwnProperty(key)? this.session.options.access[key] : false;
    }

    isSettingsAccess() : boolean {
        let access = this.settingsAccess.map((s: string) => this.isAccess(s)).filter((b: boolean) => b);
        return access.length > 0;
    }

    isProfileAccess() : boolean {
        return (this.accountSession?.current?.user ?? this.session.current.user) != null;
    }
    closeMenu() {
        this.show = false;
        this.closed = true;
    }
    changeOrg(){
        if(!this.showChangeOrg) {
            return;
        }
        this.closeMenu();
        // this.newOrganization.emit(this.selectedOrg);
        window.location.href = environment.loginBaseUri +"/organizations" ;
    }

    openApps(){
        if(!this.showSwitchApp) {
            return;
        }
        this.closeMenu();
        // go to login uri /apps
        window.open(environment.loginBaseUri +"/apps", "_blank");
    }

    
    toggleUserMenu() {
        this.closed = !this.closed;
        if (this.closed) {
            setTimeout(() => {
                this.show = false;
            }, 500); // 500 milliseconds = 0.5 seconds to let slide work before dissapear
        } else {
            this.show = true;
        }
        if(!this.initialized)
            this.initialized = true;
    }
    /**
     *  This function is designed to be triggered in mobile when a specific element is clicked. (feb-2024)
     */
    itemMobileAction(){
        // Check if the user is on a mobile device (handset size)
        this.closeMenu();
        // If not on mobile, do nothing (or add alternative logic if needed)
    }
}
